(function($) {
    "use strict";
    $(function() {

        $('.js-scroll-to-item').click(function(){
            var id = $(this).data('scroll-id');
            document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        
    });
})(jQuery);